"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/**
 * Services to be injected.
 * @typedef {Object} Services
 * @property {Object} logger - Logger-like service, see the logger implementation
 * @property {Object} config - A ConfigurationManager-like service
 * @property {Object} auth - An AuthenticationService-like service
 * @property {Object} httpService - An network-like service
 * @property {Object?} hasuraService - An hasura-like service
 *
 * */
/**
 * Base class for a data fetching service
 * Extend this and provide it to the BaseDataService for dependency injection
 */
var BaseService = /*#__PURE__*/function () {
  /**
   * THe hasura service is not being automatically provided by the {@link BaseDataService} class, so you have to provide it manually
   * @param {Services} services
   */
  function BaseService(_ref) {
    var config = _ref.config,
      httpService = _ref.httpService,
      auth = _ref.auth,
      logger = _ref.logger,
      hasuraService = _ref.hasuraService;
    (0, _classCallCheck2["default"])(this, BaseService);
    (0, _defineProperty2["default"])(this, "_config", void 0);
    (0, _defineProperty2["default"])(this, "_httpService", void 0);
    (0, _defineProperty2["default"])(this, "_auth", void 0);
    (0, _defineProperty2["default"])(this, "_logger", void 0);
    (0, _defineProperty2["default"])(this, "_hasuraService", void 0);
    this._config = config;
    this._httpService = httpService;
    this._auth = auth;
    this._logger = logger;
    this._hasuraService = hasuraService;
  }

  /**
   * Returns the url given the current scheme
   * Right now it uses the one stored in the config object
   */
  return (0, _createClass2["default"])(BaseService, [{
    key: "url",
    get: function get() {
      return this._config.get("APIURL");
    }

    /**
     * Returns the token given the current scheme
     * Right now it returns the token coming from the authentication service
     */
  }, {
    key: "token",
    get: function get() {
      return this._auth.token;
    }
  }]);
}();
module.exports = BaseService;